/**
 * The media queries of the shadow root styles, interpolated into their css`` as `@media ${narrow}`.
 *
 * A custom property cannot stand in a media query, so the breakpoints are here instead of in
 * base.css. The light DOM stylesheets (app.css, dash-pages.css) cannot import them: they repeat
 * the values they use, with a comment.
 */
import { unsafeCSS } from 'lit';

/** A phone held upright: the tightest layout. */
export const phone = unsafeCSS('(max-width: 30rem)');

/** A phone: tables become cards, the header nav scrolls, forms stack. */
export const narrow = unsafeCSS('(max-width: 40rem)');

/** A small tablet: the two sides of an instance stack. */
export const medium = unsafeCSS('(max-width: 48rem)');

/** Below a laptop: two-column layouts (overview, instance, editors) become one column. */
export const stacked = unsafeCSS('(max-width: 64rem)');

/** A finger, not a pointer: bigger targets, fields that do not make Safari zoom. */
export const touch = unsafeCSS('(pointer: coarse)');

/**
 * A finger, or a window as narrow as a phone's: controls as big as --touch-target, fields set at
 * a size Safari does not zoom into. Not touch alone: a phone-wide desktop window, or the
 * responsive view of the developer tools, would otherwise get the controls of a desktop.
 */
export const touchOrNarrow = unsafeCSS('(pointer: coarse), (max-width: 40rem)');

/** The system asks for less motion. */
export const reducedMotion = unsafeCSS('(prefers-reduced-motion: reduce)');
